'use strict';

var ParamsViewportFactory = function ParamsViewportFactory() {
  var ParamsViewport = function ParamsViewport(containerWidth, containerHeight) {
    var padding = {
      top: 5,
      bottom: 22,
      left: 95,
      right: 95
    };
    var width = containerWidth - (padding.left + padding.right);
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      maxGroupWidth: 15,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding
    };
  };
  return ParamsViewport;
};
ParamsViewportFactory.$inject = [];
module.exports = ParamsViewportFactory;